import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as thunks from 'features/thunks'
import ProfileRole from './profile-role-model'
import {
  CreateProfileRoleAsync,
  DeleteProfileRoleAsync,
  LoadProfileRolesAsync,
} from './profileRole-thunk'
const initialState: profileRoleSliceState = {
  profileRole: [],
  selected_profileRole: '',
  is_loading_profileRole: false,
  is_creating_profileRole: false,
  is_deleting_profileRole: false,
}
export interface profileRoleSliceState {
  profileRole: ProfileRole[]
  selected_profileRole?: string
  is_loading_profileRole: boolean
  is_creating_profileRole: boolean
  is_deleting_profileRole: boolean
}
export const profileRoleSlice = createSlice({
  name: 'profileRole',
  initialState,
  reducers: {
    setSelectedprofileRole: (state, action) => {
      state.selected_profileRole = action.payload
    },
    clearStateprofileRole: (state) => {
      state.profileRole = []
      state.is_loading_profileRole = false
      state.is_creating_profileRole = false
      state.is_deleting_profileRole = false
    },
    mergeprofileRole: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileRole = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileRole = merge(state.profileRole, payload) as any
        }
      }
    },

    add_profileRole: (state, action) => {
      if (action.payload) {
        state.profileRole = [...state.profileRole, action.payload]
      }
    },
    set_profileRole: (state, action) => {
      let { key, value, id } = action.payload
      state.profileRole = state.profileRole.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.DeletePlayerRoleAsync.pending, (state) => {
      state.is_loading_profileRole = true
    })
    builder.addCase(thunks.DeletePlayerRoleAsync.fulfilled, (state, action) => {
      state.is_loading_profileRole = false
      handleResult(action, state)
    })
    builder.addCase(thunks.DeletePlayerRoleAsync.rejected, (state) => {
      state.is_loading_profileRole = false
    })

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileRolesAsync.pending, (state) => {
      state.is_loading_profileRole = true
    })
    builder.addCase(LoadProfileRolesAsync.fulfilled, (state, action) => {
      state.is_loading_profileRole = false
      if (action.payload) {
        state.profileRole = action.payload
      }
    })
    builder.addCase(LoadProfileRolesAsync.rejected, (state) => {
      state.is_loading_profileRole = false
    })
    builder.addCase(CreateProfileRoleAsync.pending, (state) => {
      state.is_creating_profileRole = true
    })
    builder.addCase(CreateProfileRoleAsync.fulfilled, (state) => {
      state.is_creating_profileRole = false
    })
    builder.addCase(CreateProfileRoleAsync.rejected, (state) => {
      state.is_creating_profileRole = false
    })
    builder.addCase(DeleteProfileRoleAsync.pending, (state) => {
      state.is_deleting_profileRole = true
    })
    builder.addCase(DeleteProfileRoleAsync.fulfilled, (state, action) => {
      state.is_deleting_profileRole = false
      if (state.profileRole) {
        state.profileRole = state.profileRole.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProfileRoleAsync.rejected, (state) => {
      state.is_deleting_profileRole = false
    })
  },
})

function handleResult(action: any, state: profileRoleSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_profileRole = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.profileRole = merge(state.profileRole, payload) as any
    }
  }
}

export const {
  clearStateprofileRole,
  setSelectedprofileRole,
  set_profileRole,
  mergeprofileRole,
  add_profileRole,
} = profileRoleSlice.actions

export const get_profileRole =
  (id?: string) =>
  (state: {
    profileRole: {
      profileRole: ProfileRole[]
    }
  }): ProfileRole | null => {
    let temp = state?.profileRole?.profileRole?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profileRole?.profileRole[0] || null
  }
export const get_selected_profileRole = (state: {
  profileRole: profileRoleSliceState
}): ProfileRole | null => {
  let id = state?.profileRole?.selected_profileRole
  let temp = state?.profileRole?.profileRole?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileRole = (state: {
  profileRole: {
    profileRole: ProfileRole[]
  }
}): ProfileRole[] => {
  let temp = state?.profileRole?.profileRole
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileRole_busy = (state: {
  profileRole: profileRoleSliceState
}) => {
  return (
    state?.profileRole.is_deleting_profileRole ||
    state?.profileRole.is_loading_profileRole ||
    state?.profileRole.is_creating_profileRole
  )
}
export const is_deleting_profileRole_busy = (state: {
  profileRole: profileRoleSliceState
}) => {
  return state?.profileRole.is_deleting_profileRole
}
export const is_loading_profileRole_busy = (state: {
  profileRole: profileRoleSliceState
}) => {
  return state?.profileRole.is_loading_profileRole
}
export const is_creating_profileRole_busy = (state: {
  profileRole: profileRoleSliceState
}) => {
  return state?.profileRole.is_creating_profileRole
}

export default profileRoleSlice.reducer
